import { Client } from 'urql';
import { schoolPageBySlugTabContentQuery } from './schoolPageBySlugTabContentQuery';
import { formatChildPath, formatPathnameToSchoolSlug } from '../helpers/formatPathnameToSchoolSlug';

interface FetchSchoolPageBySlugTabContent {
  client: Client;
  pathname: string;
  schoolId: string;
  childPath?: string;
}

export const fetchSchoolPageBySlugTabContent = async ({
  client,
  pathname,
  schoolId,
  childPath,
}: FetchSchoolPageBySlugTabContent) => {
  const { data, error } = await client
    .query(schoolPageBySlugTabContentQuery, {
      slug: formatPathnameToSchoolSlug(pathname, childPath),
      id: schoolId,
      path: formatChildPath(childPath),
      imageFormatWebp: 'WEBP',
      page: 1,
    })
    .toPromise();
  return { data, error };
};
